/** @format */

export function loadSisComponentsTranslations(lang: string): Promise<any> {
    // The Webpack magic comments cause the translation files to be extracted into their own lazy loaded chunks.
    // Without the comments, the app for some reason throws the infamous bootstrapping error during page load:
    // "Trying to get the Angular injector before bootstrapping an Angular module."
    // See Webpack docs for details: https://webpack.js.org/api/module-methods/#magic-comments
    return import(/* webpackChunkName: 'components-[request]', webpackInclude: /\.json$/ */ `./${lang}.json`);
}
